import ProfileIcon from "../TV/HomePage/ProfileIcon";
import "./index.sass";

interface ProfileAndTimeProps {
  bg: string;
  time: string;
  currentProfile?: { name: string; color: string };
}

const ProfileAndTime = ({ bg, time, currentProfile }: ProfileAndTimeProps) => {
  return (
    <div id="profile-and-time">
      <img className="profile-and-time-bg" src={bg} alt="" />
      <div className="profile-and-time-time">{time}</div>
      <div className="profile-and-time-name">{currentProfile?.name ?? ""}</div>
      <ProfileIcon
        handleOnClick={() => {}}
        color={currentProfile?.color}
        style={{
          position: "absolute",
          top: "var(--height-68)",
          right: "var(--width-70)",
          width: "var(--width-20)",
          height: "var(--height-20)",
        }}
      />
    </div>
  );
};

export default ProfileAndTime;
